import { UrlBasedUsageTracker } from '../../../lib/utils/tool-usage'
import { useUserService } from '../../../lib/hooks'
import { removeLocalStorageItem } from '../../../lib/utils/local-storage'
import {
  getCountSubmitFromLocalStorage,
  getExpirationTimestampFromLocalStorage,
  maxCountSubmitAnonymous,
} from './local-storage-state'

export const useShouldTriggerUsageWall = (usageTracker?: UrlBasedUsageTracker): boolean => {
  const { isAnonymous } = useUserService().currentUser

  if (!isAnonymous) {
    return false
  }

  if (usageTracker) {
    return !usageTracker.checkToolUsageState().canUse
  } else {
    const [expirationLocalStorageKey, expirationValue] = getExpirationTimestampFromLocalStorage()
    const [countLocalStorageKey, countValue] = getCountSubmitFromLocalStorage()

    const dateNow = Date.now()
    if (dateNow > expirationValue) {
      removeLocalStorageItem(expirationLocalStorageKey)
      removeLocalStorageItem(countLocalStorageKey)

      return false
    } else {
      return countValue >= maxCountSubmitAnonymous
    }
  }
}
